import { FC } from 'react';

import classNames from 'classnames';

import ImageProxy from '@next-image-proxy';

import {
  magicIdModalBg768px,
  magicIdModalBg992px,
  magicIdModalBg1400px,
  magicIdModalGirl,
} from '@shared/assets/images/scope/magicId';

const CompleteMagicIdModalLeftDecoration: FC = () => (
  <div
    className={classNames(
      'relative w-full hidden max-w-[180px] h-[400px] md:block 2xl:max-w-[280px]',
    )}
  >
    <picture className="w-full h-[400px] rounded-bl-xl rounded-tl-xl">
      <source srcSet={magicIdModalBg1400px.src} media="(min-width: 1400px)" />
      <source srcSet={magicIdModalBg992px.src} media="(min-width: 768px)" />
      <ImageProxy className="w-full rounded-bl-xl rounded-tl-xl" src={magicIdModalBg768px} alt="" />
    </picture>

    <ImageProxy
      className="absolute object-cover max-w-[350px] bottom-[-30px] left-[-50%] 2xl:bottom-[-10px] 2xl:left-[-25%]"
      src={magicIdModalGirl}
      width={320}
      height={350}
      alt=""
      quality={100}
    />
  </div>
);

export default CompleteMagicIdModalLeftDecoration;
